export default __webpack_public_path__ + "media/zurb/img/events/wired/wired-img2-a12dd4d0f1e937b2176131ff711710d5.png";